module.exports = __webpack_public_path__ + "static/media/logo-2.455bac1f.svg";